var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('v-autocomplete',{attrs:{"items":_vm.items,"item-text":"name","item-value":"id","label":_vm.label,"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }